export const reportsDefinitions = [
  {
    id: 'organizations-report',
    title: 'Organizations Overview Report',
    description:
      'An overview of existing organizations in the DVZA FHIR storage. The report contains information about organizations such as their FHIR Resource ID, name, date when it was uploaded, postal code, AGB, URA, MedMij-naam, first permitted disclosure date and disclosure prohibited restrictions. The report only contains organizations that have either a last full upload date or first permitted ehr disclosure date.'
  }
];
